import { sendOtp, verifyOtp, logout } from "../../services/auth.service";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { setHeaderAuthorization } from "../../services/api";

export const doSendOtp = createAsyncThunk(
  "auth/sendOtp",
  async ({ email }, { rejectWithValue }) => {
    try {
      const response = await sendOtp({
        email: email,
      });
      return response;
    } catch (error) {
      console.log(error);
      return rejectWithValue(error);
    }
  }
);

export const doVerifyOtp = createAsyncThunk(
  "auth/verifyOtp",
  async (body, { rejectWithValue }) => {
    try {
      const response = await verifyOtp(body);

      if (response.status < 200 || response.status >= 300) {
        return rejectWithValue("Error: Invalid status code");
      }

      const accessToken = response.data?.authentication?.accessToken;
      const firstTime = response.data?.isFirstTimeUser;
      if (!accessToken) {
        return rejectWithValue("Error: No access token in response");
      }

      setHeaderAuthorization(accessToken);
      return { accessToken: accessToken, firstTimeUser: firstTime };
    } catch (error) {
      console.log(error);
      return rejectWithValue(error.message || "An unknown error occurred");
    }
  }
);

export const doLogout = createAsyncThunk(
  "auth/logout",
  async ({ body }, { rejectWithValue }) => {
    try {
      const response = await logout(body);
      setHeaderAuthorization();
      localStorage.clear();
      return response;
    } catch (error) {
      console.log(error);
      return rejectWithValue(error);
    }
  }
);
